import AddFavoriteSkeleton from "./AddFavoriteSkeleton";
import SupportSkeleton from "./SupportSkeleton";

const Skeleton = {
  AddFavorite: AddFavoriteSkeleton,
  Support: SupportSkeleton,
};

export default Skeleton;
